module.exports = __webpack_public_path__ + "img/ticks.375e4f5b.svg";